import { render, staticRenderFns } from "./gradeList.vue?vue&type=template&id=927ac700&scoped=true&"
import script from "./gradeList.vue?vue&type=script&lang=js&"
export * from "./gradeList.vue?vue&type=script&lang=js&"
import style0 from "./gradeList.vue?vue&type=style&index=0&id=927ac700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927ac700",
  null
  
)

/* custom blocks */
import block0 from "./gradeList.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(component)

export default component.exports